export default __webpack_public_path__ + "static/media/person.e56cf2d3.svg";